import getHostname from './getHostname';

const getCsrfToken = async (): Promise<string> => {
  const response = await fetch(`https://${getHostname()}/api/v2/csrf`, {
    credentials: 'include',
  });
  const body = await response.json();
  return body.csrf_token;
};

export default getCsrfToken;
